export const manualCategories = [
  {
    id: 'preparation',
    name: '入園準備',
    icon: 'ri-briefcase-line',
    color: 'teal',
    description: '保育園入園に向けた準備ガイド'
  },
  {
    id: 'emergency',
    name: '緊急時対応',
    icon: 'ri-alarm-warning-line',
    color: 'rose',
    description: '緊急時の対応フローと連絡先'
  },
  {
    id: 'daily',
    name: '日常ケア',
    icon: 'ri-heart-pulse-line',
    color: 'purple',
    description: '毎日のケアの工夫とコツ'
  },
  {
    id: 'experience',
    name: '先輩の声',
    icon: 'ri-parent-line',
    color: 'amber',
    description: '先輩ママの体験談とアドバイス'
  }
];

export const manualArticles = [
  {
    id: 'm1',
    categoryId: 'preparation',
    title: 'はじめての入園準備リスト',
    summary: '医療的ケア児の保育園入園に必要な準備を、チェックリスト形式でまとめました。',
    content: `# はじめての入園準備リスト

## 1. 書類の準備（入園3ヶ月前〜）

### 必須書類
- [ ] 入園申込書
- [ ] 医師の診断書・意見書
- [ ] 医療的ケア指示書
- [ ] 緊急連絡先リスト（3名以上）
- [ ] 保険証・医療証のコピー

### 任意だが推奨される書類
- [ ] お子さんの1日のスケジュール表
- [ ] ケアの手順書（写真付き）
- [ ] 好きなこと・嫌いなことリスト
- [ ] 体調変化のサイン一覧

---

## 2. 医療機器・物品の準備（入園1ヶ月前〜）

### 園に預けるもの
- [ ] 吸引器（予備バッテリー含む）
- [ ] 吸引カテーテル（1週間分）
- [ ] 経管栄養セット
- [ ] 注入ポンプ（必要な場合）
- [ ] 酸素ボンベ・カニューラ（必要な場合）
- [ ] 体温計・パルスオキシメーター

### 毎日持参するもの
- [ ] 着替え（3セット以上）
- [ ] おむつ・おしりふき
- [ ] ミルク・栄養剤
- [ ] 内服薬（1日分）
- [ ] 連絡帳

---

## 3. 園との打ち合わせ（入園2週間前〜）

### 確認すべきこと
- [ ] 看護師の配置時間
- [ ] 緊急時の対応フロー
- [ ] 主治医との連携方法
- [ ] 保護者への連絡基準
- [ ] 慣らし保育のスケジュール

### 実技指導
- [ ] 吸引の実演・見学
- [ ] 経管栄養の実演・見学
- [ ] 体位変換の方法
- [ ] 機器のトラブル対応

---

## 4. 心の準備

### お母さん自身のケア
- 初日は不安で当たり前です
- 園に電話して様子を聞いても大丈夫
- 最初の1週間は特に疲れます。無理せず休んでください
- 「預けることは悪いこと」ではありません

### 先輩ママからのアドバイス
「最初の1ヶ月は毎日泣きながら送り出していました。でも、先生方が本当に丁寧に見てくださって、今では子どもも私も笑顔で通っています。」（Aさん・3歳児のママ）

---

## 5. 入園後の確認事項

### 1週間後
- [ ] お子さんの様子の変化
- [ ] 園での食事・睡眠の状況
- [ ] ケアの実施状況
- [ ] 困っていることの共有

### 1ヶ月後
- [ ] 慣らし保育の完了
- [ ] 通常保育への移行
- [ ] 定期面談の実施

---

**困ったときは「みんなの休憩室」で相談してください。先輩ママやみやぎスマイル・パートナーが応援しています！**`,
    author: 'スマイル・パートナー',
    authorId: 'partner-003',
    updatedAt: '2025-01-10T10:00:00',
    views: 245,
    helpful: 89
  },
  {
    id: 'm2',
    categoryId: 'emergency',
    title: '緊急時対応フロー（家庭版）',
    summary: '自宅で緊急事態が発生した際の対応手順を、フローチャート形式で解説します。',
    content: `# 緊急時対応フロー（家庭版）

## まず落ち着いて：深呼吸を3回

緊急時こそ、冷静な判断が必要です。このページをブックマークしておき、いつでも見られるようにしてください。

---

## 緊急度の判断

### 🚨 すぐに119番（救急車）

以下の症状がある場合は、迷わず救急車を呼んでください：

- 呼吸が止まっている、または極端に弱い
- 顔色が真っ青、唇が紫色
- 意識がない、呼びかけに反応しない
- けいれんが5分以上続く
- SpO2が85%以下で改善しない
- 大量の出血

**119番通報時に伝えること**
- 「医療的ケア児です」と最初に伝える
- 住所と目印
- お子さんの年齢と症状
- 使用している医療機器（人工呼吸器、酸素など）

---

### ⚠️ 主治医に連絡（診療時間内）

- 発熱（38.5度以上）
- 嘔吐・下痢が続く
- いつもと様子が違う
- SpO2が90%前後で不安定

**主治医連絡先**
- 病院名：＿＿＿＿＿＿＿＿＿＿
- 電話番号：＿＿＿＿＿＿＿＿＿＿
- 担当医：＿＿＿＿＿＿＿＿＿＿

---

### 📞 夜間・休日の相談先

**宮城県こども夜間安心コール**
- 電話：#8000（プッシュ回線・携帯電話）
- 電話：022-212-9390（ダイヤル回線・IP電話）
- 時間：19:00〜翌朝8:00（毎日）

**宮城県立こども病院（救急外来）**
- 電話：022-391-5111
- 住所：仙台市青葉区落合4-3-17

---

## 症状別対応ガイド

### 吸引が必要な時

- 手を洗う
- 吸引器の電源を入れる
- 新しいカテーテルを使用
- 吸引圧を確認（-20kPa程度）
- 1回の吸引は10秒以内
- 吸引後、SpO2を確認

**吸引器が故障した場合**
- 予備の吸引器を使用
- なければ、口腔内は清潔なガーゼで拭き取る
- すぐに医療機器業者に連絡

---

### 経管栄養のトラブル

**チューブが抜けた**
- 慌てずに、抜けた時間をメモ
- 主治医または訪問看護師に連絡
- 自己判断で入れ直さない

**注入中に嘔吐した**
- 注入を中止
- 体を横向きにする
- 口の中を清潔にする
- 30分後に少量から再開

---

### 発熱時の対応

**38.5度以上の発熱**
- 水分補給（経口または経管）
- 薄着にする
- 解熱剤の使用（医師の指示通り）
- 1時間後に再検温

**注意すべきサイン**
- ぐったりしている
- 水分が取れない
- 呼吸が速い・苦しそう

→ すぐに医療機関へ

---

## 災害時の備え

### 持ち出しバッグの中身
- [ ] お薬手帳・診察券
- [ ] 3日分の内服薬
- [ ] 吸引カテーテル（1箱）
- [ ] 経管栄養セット
- [ ] 栄養剤（3日分）
- [ ] おむつ・着替え
- [ ] 母子手帳のコピー
- [ ] 緊急連絡先リスト

---

### 停電時の対応

- 吸引器：予備バッテリーで約2時間使用可能
- 酸素濃縮器：酸素ボンベに切り替え
- 人工呼吸器：バッテリー残量を確認し、必要に応じて避難

---

**このページを印刷して、冷蔵庫に貼っておくことをおすすめします。**`,
    author: 'スマイル・パートナー',
    authorId: 'partner-001',
    updatedAt: '2025-01-12T14:30:00',
    views: 312,
    helpful: 156
  },
  {
    id: 'm3',
    categoryId: 'daily',
    title: 'テープかぶれ対策の完全ガイド',
    summary: '経管栄養や気管切開のテープによる皮膚トラブルを防ぐ方法をまとめました。',
    content: `# テープかぶれ対策の完全ガイド

医療用テープによる皮膚トラブルは、多くのご家族が悩まれています。このガイドでは、看護師と先輩ママの知恵を集めました。

---

## なぜかぶれるの？

### 主な原因
- **テープの粘着剤** - 長時間の接触で刺激に
- **蒸れ** - テープ下の湿気で皮膚がふやける
- **摩擦** - 剥がす時の刺激
- **汗や唾液** - テープの下に入り込む

---

## 予防策：貼る前のケア

### 1. 皮膚保護剤を使う

**おすすめ商品**
- キャビロン™ 非アルコール性皮膚保護剤
- 3M™ キャビロン™ ポリマーコーティング
- アルケア社 プロテクトーン

**使い方**
- 清潔な肌に薄く塗る
- 完全に乾くまで待つ（約30秒）
- その上からテープを貼る

### 2. テープの選び方

**肌に優しいテープ**
- シルキーテックス（アルケア）
- マイクロポア™（3M）
- 優肌絆（ニチバン）

**避けた方がいいテープ**
- 粘着力が強すぎるもの
- 通気性の悪いもの

---

## 貼り方の工夫

### 基本の貼り方
- 皮膚を清潔にして、完全に乾かす
- テープは引っ張らずに貼る
- 角を丸くカットする（剥がれにくくなる）
- 同じ場所に貼り続けない

### 位置をずらすローテーション

**経管栄養チューブの場合**
- 月曜：右頬
- 火曜：左頬
- 水曜：鼻の上
- 木曜：右頬（少し上）
- 金曜：左頬（少し上）

毎日少しずつ位置をずらすことで、同じ場所への負担を減らせます。

---

## 剥がし方のコツ

### 絶対にやってはいけないこと
❌ 勢いよく剥がす
❌ 無理に引っ張る
❌ 乾いた状態で剥がす

### 正しい剥がし方
- **ぬるま湯で湿らせる** - コットンやガーゼを使用
- **剥離剤を使う** - リムーバーを端に塗る
- **ゆっくり剥がす** - 皮膚を押さえながら、テープを寝かせるように
- **すぐに保湿** - ワセリンやベビーローションを塗る

**おすすめ剥離剤**
- アルケア リムーバー
- 3M™ シリコーン系粘着剥離剤

---

## かぶれてしまった時の対処法

### 軽度のかぶれ（赤み程度）
- テープを貼る位置を変える
- 保湿剤をこまめに塗る
- 通気性の良いテープに変更

### 中等度のかぶれ（ただれ・水ぶくれ）
- 主治医または訪問看護師に相談
- 処方された軟膏を使用
- テープを使わない固定方法を検討

### 重度のかぶれ（出血・感染の疑い）
→ すぐに医療機関を受診してください

---

## 先輩ママの裏ワザ

### 「ガーゼクッション法」（Bママ・5歳児）
「テープを貼る前に、薄いガーゼを1枚挟むんです。直接肌に触れないから、かぶれが激減しました！」

### 「夜だけテープフリー」（Cママ・3歳児）
「夜寝る時だけ、テープを外して帽子型のネットで固定。朝起きたら新しいテープに交換します。」

### 「保湿は朝晩2回」（Dママ・4歳児）
「テープを貼っていない部分は、朝晩しっかり保湿。ワセリンを塗ってからテープを貼ると、剥がす時も楽です。」

---

## よくある質問

**Q: 毎日テープを交換した方がいいですか？**

A: 基本的には毎日交換をおすすめします。ただし、皮膚の状態が良好で、テープがしっかり貼れている場合は、2日に1回でも大丈夫です。主治医と相談してください。

**Q: 市販の絆創膏でも大丈夫？**

A: 医療用テープの方が肌に優しく、粘着力も適切です。市販の絆創膏は粘着力が強すぎることがあるので、避けた方が無難です。

**Q: 赤ちゃん用のテープはありますか？**

A: 「優肌絆」や「マイクロポア」は赤ちゃんにも使えます。ただし、個人差があるので、小さく試してから使ってください。

---

**それでも困った時は「みんなの休憩室」で相談を！同じ悩みを乗り越えた先輩ママがたくさんいます。**`,
    author: 'スマイル・パートナー（看護師）',
    authorId: 'partner-007',
    updatedAt: '2025-01-14T09:15:00',
    views: 428,
    helpful: 203
  },
  {
    id: 'm4',
    categoryId: 'experience',
    title: '先輩ママの1日スケジュール',
    summary: '医療的ケア児を育てながら働く先輩ママの、リアルな1日を紹介します。',
    content: `# 先輩ママの1日スケジュール

## Eさん（35歳・会社員）のケース

**お子さん：** 4歳・経管栄養・吸引が必要
**保育園：** 企業主導型保育園（看護師常駐）
**勤務形態：** 時短勤務（9:30〜16:00）

---

### 6:00 起床
- 自分の身支度を先に済ませる
- 朝食の準備（自分と上の子の分）

「以前は子どもを先に起こしていましたが、自分の準備を先にした方が余裕ができました。」

---

### 6:30 お子さんを起こす
- おむつ交換
- 着替え
- 朝の吸引（2〜3回）
- 経管栄養の準備

---

### 7:00 朝の注入開始
- 注入ポンプをセット（200ml・1時間）
- 注入中に上の子の朝食
- 保育園の持ち物チェック

**持ち物リスト**
- 着替え3セット
- おむつ・おしりふき
- 吸引カテーテル（5本）
- 昼食用の栄養剤
- 連絡帳

---

### 8:00 注入終了・出発準備
- 注入後の吸引
- 口腔ケア
- 荷物を車に積む

---

### 8:30 保育園へ送り
- 看護師さんに申し送り
- 「今朝の様子」「夜の睡眠」を伝える
- 連絡帳を渡す

「最初は毎朝泣いていましたが、今では先生に会うと笑顔になります。子どもは順応が早いですね。」

---

### 9:00 上の子を幼稚園へ送り

---

### 9:30 出社
- 時短勤務で16時まで
- 昼休みに保育園から連絡がないかチェック

「最初の1ヶ月は、昼休みに毎日保育園に電話していました。今は慣れて、連絡がなければ大丈夫だと思えるようになりました。」

---

### 16:00 退社

---

### 16:30 保育園お迎え
- 看護師さんから1日の報告を聞く
- 連絡帳を確認
- 吸引カテーテルの残数チェック

---

### 17:00 上の子を幼稚園お迎え

---

### 17:30 帰宅
- 夕方の吸引
- 夕食の準備（上の子と自分の分）

---

### 18:00 夕方の注入開始
- 注入ポンプをセット（250ml・1.5時間）
- 上の子と夕食
- 洗濯物を畳む

---

### 19:30 注入終了
- 注入後の吸引
- お風呂の準備

---

### 20:00 入浴
- 上の子を先に入れる
- お子さんは夫が担当（シャワー浴）

「夫婦で役割分担を決めたら、すごく楽になりました。私が料理、夫が入浴担当です。」

---

### 21:00 就寝準備
- 寝る前の吸引
- おむつ交換
- 寝室へ移動

---

### 21:30 上の子就寝

---

### 22:00 お子さん就寝
- 吸引器を枕元にセット
- パルスオキシメーターを装着

---

### 22:30 自分の時間
- 洗濯物を干す
- 明日の準備
- スマホでリラックス

「この30分が私の唯一の自由時間。みやぎスマイル・ポートの掲示板を見たり、好きなドラマを見たりしています。」

---

### 23:00 就寝

---

### 夜中 2:00、5:00
- アラームで起きて吸引
- すぐに寝る

「夜中の吸引は慣れました。でも、風邪をひくと回数が増えて辛いです。そんな時は『みんなの休憩室』で愚痴を聞いてもらっています。」

---

## Eさんからのメッセージ

「最初は『仕事と育児の両立なんて無理』と思っていました。でも、保育園の先生方、職場の理解、そして何より同じ境遇のママたちの支えがあって、今があります。

完璧を目指さなくていい。手抜きできるところは手抜きして、頼れる人には頼る。それが長く続けるコツだと思います。

一人で抱え込まないで。みやぎスマイル・ポートには、あなたの気持ちを分かってくれる人がたくさんいますよ。」

---

## 他の先輩ママのスケジュールも見たい方へ

「みんなの休憩室」の「保育園・社会参加」カテゴリで、他のママたちのスケジュールも共有されています。ぜひ参考にしてください！`,
    author: '先輩ママ・Eさん',
    authorId: 'partner-005',
    updatedAt: '2025-01-08T16:00:00',
    views: 567,
    helpful: 289
  },
  {
    id: 'm5',
    categoryId: 'daily',
    title: '夜中のアラーム対策',
    summary: '医療機器のアラーム音で家族が眠れない問題を解決する工夫を集めました。',
    content: `# 夜中のアラーム対策

「ピーピー」「ピピピ」というアラーム音で、家族全員が起きてしまう...。多くのご家族が抱える悩みです。

---

## アラームの種類と対応

### 1. 吸引器のアラーム

**原因**
- 吸引圧の低下
- カテーテルの詰まり
- バッテリー残量低下

**対策**
- 寝る前に必ず吸引圧をチェック
- カテーテルは毎晩新しいものに交換
- バッテリーは満充電にしておく

---

### 2. パルスオキシメーターのアラーム

**原因**
- センサーのズレ
- 体動
- SpO2の低下

**対策**
- センサーを固定用テープで補強
- アラーム設定値を主治医と相談（85%など）
- 音量を下げられる機種に変更

---

### 3. 注入ポンプのアラーム

**原因**
- 注入完了
- チューブの閉塞
- 空気混入

**対策**
- 夜間は注入しないスケジュールに変更
- チューブの取り回しを工夫

---

## 音を小さくする工夫

### 先輩ママの裏ワザ

**「タオルボックス法」（Fママ・6歳児）**

「吸引器を小さな段ボール箱に入れて、周りにタオルを詰めています。音が半分くらいになりました！ただし、熱がこもらないように通気口は確保してください。」

**「別室モニター法」（Gママ・4歳児）**

「吸引器を隣の部屋に置いて、ベビーモニターで音を聞いています。アラームが鳴ったらすぐに駆けつけられる距離です。」

**「イヤホン接続法」（Hママ・5歳児）**

「パルスオキシメーターにイヤホンジャックがあったので、Bluetoothトランスミッターを使って、私のスマホに音を飛ばしています。家族は起きません。」

---

## 家族への配慮

### 上のお子さんがいる場合
- 別の部屋で寝てもらう
- 耳栓を使ってもらう
- 「協力してくれてありがとう」と感謝を伝える

### パートナーとの役割分担
- 「今日は私が対応するから、あなたは耳栓して寝て」
- 交代制にする（月・水・金は妻、火・木・土は夫など）

**Iさん（パパ）のコメント**

「最初は妻に任せきりでしたが、交代制にしたら妻の表情が明るくなりました。自分も子どものケアに慣れて、自信がつきました。」

---

## 睡眠の質を上げる工夫

### 寝る前のルーティン
- 吸引を念入りに行う
- 体位を整える
- 室温・湿度を調整
- 自分もリラックスする時間を持つ

### 昼寝の活用

「夜中に起きるのは仕方ない」と割り切って、お子さんが保育園に行っている間や、昼寝の時間に自分も寝る。

**Jママのコメント**

「『夜まとめて寝る』という常識を捨てたら、楽になりました。昼寝は罪悪感じゃなくて、必要なケアです。」

---

## それでも辛い時は

### 訪問看護の夜間対応
- 自治体によっては、夜間の訪問看護サービスがあります
- ケアマネージャーに相談してみてください

### レスパイトケア
- 短期入所（ショートステイ）を利用
- 月に1〜2回でも、まとまった睡眠が取れると回復します

### 「みんなの休憩室」で愚痴る
- 夜中に起きた時、掲示板に「今起きた...」と書き込むだけでも気が楽になります
- 同じ時間に起きている仲間がいると分かるだけで、孤独感が減ります

---

**睡眠不足は、心身の健康に直結します。一人で抱え込まず、使えるサービスは全部使ってください。**`,
    author: 'スマイル・パートナー',
    authorId: 'partner-010',
    updatedAt: '2025-01-11T22:00:00',
    views: 391,
    helpful: 178
  },
  {
    id: 'm6',
    categoryId: 'experience',
    title: '保育園選びで後悔しないために',
    summary: '医療的ケア対応の保育園を選ぶ際のチェックポイントを、経験者が語ります。',
    content: `# 保育園選びで後悔しないために

---

## 見学前の準備

### 確認すべき基本情報
- [ ] 看護師の配置（常駐か、時間帯は？）
- [ ] 受け入れ実績（何人の医療的ケア児を受け入れているか）
- [ ] 対応可能なケアの種類
- [ ] 保育時間（延長保育の有無）
- [ ] 給食対応（経管栄養の場合の対応）

### 質問リストを作る

見学時に聞きたいことをメモしておきましょう。緊張して聞き忘れることがあります。

---

## 見学時のチェックポイント

### 1. 看護師さんとの相性

「この人になら、子どもを任せられる」と思えるかが一番大切です。

**チェック項目**
- 話しやすい雰囲気か
- 医療的ケアの経験は豊富か
- 保護者の不安に寄り添ってくれるか

---

### 2. 保育室の環境

- 吸引器を置くスペースがあるか
- 医療機器のコンセントは十分か
- 静かに休める場所があるか
- 他の子どもたちとの距離感

---

### 3. 緊急時の対応

- 主治医との連携方法
- 救急搬送の手順
- 保護者への連絡基準

**Kママの失敗談**

「最初の園は『何かあったらすぐ連絡します』と言われて安心していたのですが、実際は『ちょっと熱があります』『少し咳が出ています』と、些細なことで毎日電話がかかってきました。仕事になりませんでした。

次の園では、『37.5度以上で連絡』『SpO2が90%以下で連絡』など、具体的な基準を最初に決めました。これで安心して働けるようになりました。」

---

## 先輩ママが重視したポイント

### Lママ（3歳児・経管栄養）
「看護師さんが2人いる園を選びました。1人だと、その人が休みの日に預けられないので。」

### Mママ（4歳児・吸引）
「家から近い園にしました。何かあった時にすぐ駆けつけられる距離が安心です。」

### Nママ（5歳児・酸素）
「他の医療的ケア児が通っている園を選びました。先生方が慣れているので、説明が楽でした。」

---

## 慣らし保育のコツ

### 1週目：1時間だけ
- 園の雰囲気に慣れる
- 看護師さんとの信頼関係を築く

### 2週目：午前中のみ
- 給食（経管栄養）を試す
- 午前のケアを任せてみる

### 3週目：お昼寝まで
- 長時間の預かりに慣れる
- 保護者も離れる練習

### 4週目：通常保育
- フルタイムで預ける

**Oママのアドバイス**

「慣らし保育は、子どもよりも親が慣れるための時間だと思います。最初は不安で、園の前で泣いていました。でも、先生方が『大丈夫ですよ』と声をかけてくださって、少しずつ信頼できるようになりました。」

---

## 入園後に気づいたこと

### 良かったこと
- 子どもの表情が豊かになった
- 他の子どもとの関わりで刺激を受けている
- 自分の時間が持てるようになった
- 仕事に復帰できた

### 大変だったこと
- 感染症をもらいやすい
- 朝の準備が忙しい
- 保育料が高い（医療的ケア加算）

**Pママのコメント**

「大変なこともありますが、それ以上に得られるものが大きいです。子どもの成長を見ると、『預けて良かった』と心から思います。」

---

## 保育園に通えない場合

### 居宅訪問型保育
- 自宅に保育士が来てくれるサービス
- 医療的ケア児も対象

### 訪問保育
- NPO法人などが提供
- 1対1の保育

### 放課後等デイサービス
- 就学後の選択肢

---

**保育園選びは、子どもの未来を左右する大切な決断です。焦らず、納得できる園を見つけてください。**`,
    author: '先輩ママたち',
    authorId: 'partner-002',
    updatedAt: '2025-01-09T11:30:00',
    views: 445,
    helpful: 221
  }
];
